import script from "./Detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./Detail.vue?vue&type=script&setup=true&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=7fdc173a&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fdc173a"]])

export default __exports__